import ActionTypes from './container/actionType'

const ScoreReducers = (state = {
    scoreResult: []

}, action) => {
    switch (action.type) {
        case ActionTypes.ScoreView: {
            return state = {
                ...state,
                scoreResult: action.payload
            }
        }
        default: { }
    }
    return state;
}
export default ScoreReducers;


// WEBPACK FOOTER //
// ./src/reducers/scoreReducers.jsx